import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function CircularProgressIndicator() {
  return (
    <Box sx={{ display: 'flex',justifyContent: "center",alignItems: "center", }}>
      <CircularProgress />
    </Box>
  );
}